<div *ngIf="buttonsContext.showSendToLenderButtons; else otherActions">
  <button
    id="send-to-lender"
    *ngIf="!deal.supportedApiActions.hideSendToLenderPortal"
    mat-button
    [color]="'primary'"
    [disabled]="buttonsContext.disablePackageAndSend || bulkSubmitting"
    (click)="sendApplication()"
    data-cy="send-to-lender-button">
    <span *ngIf="!loading && !bulkSubmitting">Send To Lender</span>
    <mat-spinner *ngIf="loading || bulkSubmitting" diameter="24" style="display: inline-block; height: 24px; width: 24px"></mat-spinner>
  </button>
  <button
    *ngIf="deal.supportedApiActions.application"
    mat-button
    [color]="'primary'"
    [disabled]="buttonsContext.disablePackageAndSend || deal.lenderApplicationId || !questionRequirementsMet || bulkSubmitting"
    (click)="sendAPIApplication()">
    <span *ngIf="!loading && !bulkSubmitting">Send Via API</span>
    <mat-spinner *ngIf="loading || bulkSubmitting" diameter="24" style="display: inline-block; height: 24px; width: 24px"></mat-spinner>
  </button>
</div>

<ng-template #otherActions>
  <button
    *ngIf="!deal.supportedApiActions.hideSendToLenderPortal && buttonsContext.dealIsActive"
    class="send-new-package-btn"
    mat-flat-button
    [color]="'primary'"
    (click)="sendApplication()"
    [disabled]="loading || (!deal.signedApplicationDocId && !dateSigned) || bulkSubmitting">
    Send New Package
  </button>
  <button
    *ngIf="deal.supportedApiActions.application && buttonsContext.dealIsActive"
    class="send-new-package-btn"
    mat-flat-button
    [color]="'primary'"
    (click)="sendAPIApplication()"
    [disabled]="loading || (!deal.signedApplicationDocId && !dateSigned) || bulkSubmitting">
    Resend Via API
  </button>
  <button
    *ngIf="buttonsContext.showOfferReceivedButton"
    mat-flat-button
    data-cy="offer-received-button"
    [color]="'primary'"
    (click)="openOfferDialog()">
    Offer Received
  </button>
  <button
    *ngIf="deal.stage === 'inactive'"
    [color]="'primary'"
    mat-flat-button
    (click)="openReactivateDealDialog()">
    Reactivate
  </button>
  <div
    class="tw-inline-block"
    [matTooltip]="buttonsContext.hasAcceptedOffer ? '' : 'Must have an accepted offer to Ring a Deal'"
    matTooltipPosition="above"
  >
    <button
      *ngIf="buttonsContext.showRingDealButton"
      class="ring-deal-btn"
      mat-flat-button
      data-cy="ring-the-bell-button"
      [disabled]="!buttonsContext.hasAcceptedOffer || ringingDeal"
      (click)="openRingDealDialog()">
      <div *ngIf="!ringingDeal" class="ring-deal-text">
        <mat-icon class="ring-deal-icon">notifications</mat-icon>
        Ring Deal
      </div>
      <mat-spinner *ngIf="ringingDeal" diameter="24"></mat-spinner>
    </button>
  </div>
  <button
    matTooltip="When you renew this deal, an editable copy will be created and placed in active deal status"
    matTooltipPosition="above"
    *ngIf="buttonsContext.showRenewDealButton"
    class="renew-deal-btn"
    mat-button
    data-cy=renew-deal-button
    [color]="'primary'"
    [disabled]="!deal.dateClosed || loading"
    (click)="renewDeal()">
    <span *ngIf="!loading">Renew Deal</span>
    <mat-spinner *ngIf="loading" diameter="24"></mat-spinner>
  </button>
</ng-template>
